//= require jquery.jBreadCrumb.js

var ChartUtils = (function (){
  var self = {};

  self.prepareDataForReference = function( chartData, bidder_index) {
    var bidderData = [];
    $.each(chartData.series, function(serie_index, serie) {
      var splicedArray = serie.data.splice(bidder_index,1);
      var bidderValue = splicedArray[0];
      bidderData.push(bidderValue);
      serie.data = _.map(serie.data, function(value) { return value - bidderValue});
    });
    chartData.categories.splice(bidder_index,1);
    return bidderData;
  };

  self.printCurrentChartData = function() {
    var data = $('#bids-comparison-chart').data().bidsChart.chartData;
    var seriesData = _.map(data.series, function(s){return s.data;})
    document.currentChartData = data;
  },

  self.transposeSeriesIntoCategories = function (chartData){
    var data = $.extend(true, {}, chartData);

    var transposed_data = {series: [], categories: []};

    $.each(data.categories, function(bidderIndex, bidder){
      var bidder_data = [];
      var categoriesData = [];
      var parentData = [];
      var leafData = [];
      $.each(data.series, function(_, serie){
        bidder_data.push(serie.data[bidderIndex]);
        categoriesData.push(serie.self);
        parentData.push(serie.parent);
        leafData.push(serie.isLeaf);
      });
      transposed_data.series.push({ name:bidder, data:bidder_data, stack:bidder, categories:categoriesData, parents:parentData, leaves:leafData});
    });

    $.each(data.series, function(_, category){
      transposed_data.categories.push(category.name);
    });

    transposed_data.categories.reverse();

    // Stacked bars for Group View should be sorted according to the bidders (on right panel)
    // HighCharts shows first item last in stacked graphs
    // For example: http://www.highcharts.com/demo/bar-basic
    transposed_data.series.reverse();

    $.each(transposed_data.series, function(_, serie){
      serie.data.reverse();
      serie.categories.reverse();
      serie.parents.reverse();
      serie.leaves.reverse();
    });

    return transposed_data;
  };

  self.filter = function(chartData, filteringFunction){
    var dataCopy = $.extend(true, {}, chartData);
    var newSeries = $.grep( dataCopy.series, filteringFunction);
    dataCopy.series = newSeries;
    return dataCopy;
  };

  self.rootFiltering = function(datum){
    return datum.parent == "";
  };

  self.sortDataInPlace = function(currentOrderBidders, sortedBidders, seriesData){

    $.each(sortedBidders, function(sortedBidderIndex,sortedBidder){
      var unSortedBidderIndex = currentOrderBidders.indexOf(sortedBidder);
      var swapBidder = currentOrderBidders[sortedBidderIndex];
      //first change the categories
      currentOrderBidders[sortedBidderIndex]  = sortedBidder;
      currentOrderBidders[unSortedBidderIndex]= swapBidder;
      //then change each series data
      $.each(seriesData, function(_, serie){
        var swapData = serie.data[unSortedBidderIndex];
        serie.data[unSortedBidderIndex] = serie.data[sortedBidderIndex];
        serie.data[sortedBidderIndex] = swapData
      });
    });
  };

  self.drawLinesChart = function( opts, widget ){
    series = widget.chartData.series;

    var modifyDefaultOptions = function(opts){
      opts.chart.defaultSeriesType = 'line';
      opts.xAxis.labels.rotation = 300;
      opts.xAxis.labels.align = 'right';
      opts.xAxis.labels.y = 10;
      opts.xAxis.gridLineWidth = 1;
      opts.yAxis.min = 0;
      opts.yAxis.endOnTick = false;
      series.reverse()
      opts.tooltip.formatter = function() {

        var item = this;
        var data = series[item.point.x].data; //fetch the series for the category of this point i.e.: this.x == "preliminaries"

        var currentCategory = item.x;
        var currentBidder   = item.series.name;
        var tooltip = "<b>" + currentCategory + ":</b><br/>";
        $.each( data, function(index, value){
          category = widget.chartData.categories[index];
          if( currentBidder == category){
            tooltip += '<span style="font-weight:bold; color:' + item.series.color + ';">' + category + ': ' + widget.chartData.currency + ' ' +  Highcharts.numberFormat( value, 0) + '</span> <br/>';
          }else{
            tooltip += category + ': ' + widget.chartData.currency + ' ' +  Highcharts.numberFormat( value, 0) + '<br/>';
          }item
        });
        return tooltip;
      }

      opts.plotOptions.series.events.click = function(e){
        if( !widget.chartData.series[e.point.x].isLeaf ){
          var selfCategory = widget.chartData.series[e.point.x].self;
          var selfCategoryName = widget.chartData.series[e.point.x].name;
          $('#bids-breadcrumb #bids-path').show();
          widget.updateBreadCrumb(selfCategoryName, selfCategory);
          $("#currentDataParentCategory").attr("value",selfCategory);
          widget.filterDataByCategory();
        }
      }
      return opts;
    };
    var transposedData = ChartUtils.transposeSeriesIntoCategories( widget.chartData );
    widget._showChart(transposedData, modifyDefaultOptions);
  };

  self.labelColorsLoaded = false;

  self.labelColors = {
    average:  '',
    median:   '',
    min:      '',
    max:      '',
    normal:   ''
  };

  self.loadLabelColors = function() {
    self.labelColors.average = $('#biddersList p.average').css('color');
    self.labelColors.median  = $('#biddersList p.median').css('color');
    self.labelColors.min     = $('#biddersList p.leastExpensiveBidder').css('color');
    self.labelColors.max     = $('#biddersList p.mostExpensiveBidder').css('color');
    self.labelColors.normal  = $('#biddersList p.averageBidder').css('color');
    self.labelColorsLoaded   = true;
  };

  self.getLabelColor = function(labelType) {
    if (!self.labelColorsLoaded) {
      self.loadLabelColors();
    }
    labelType = labelType.toLowerCase();
    if (typeof(self.labelColors[labelType]) != 'undefined') {
      return self.labelColors[labelType];
    }
    return false;
  };

  self.labelFormatter = function(widget, showPrice) {
    var color = self.getLabelColor(widget.value);

    var priceHtml = "";
    if (showPrice) {
      priceHtml = ' ' + $("#biddersList a:contains('" + widget.value + "')").parent().find("p").text();
    }

    if (color) {
      label = '<div style="color: '+color+'; background: #00ffff; font-weight: bold;">' + widget.value + priceHtml;
    } else {
      label = '<b>' + widget.value + '</b>' + priceHtml;
    }
    return label;
  };

  self.calculatePaddingBoundaries = function(data) {
    var paddings = {
      category: 0,
      amount: 0
    };
    $.each( data, function(index, item ){
      var amount = Highcharts.numberFormat( item.y, 0);
      if (item.category.length > paddings.category || paddings.category == 0) {
        paddings.category = item.category.length;
      }
      if (amount.length > paddings.amount || paddings.amount == 0) {
        paddings.amount = amount.length;
      }
    });
    return paddings;
  };

  self.getItemPaddings = function(maxPaddingData, item) {
    var paddings = {};

    var categoryDifference = maxPaddingData.category - item.category.length;
    var categoryPadding = self.pad(categoryDifference);

    var color = "#ffffff";

    paddings.category = '<span style="color:'+color+';">'+categoryPadding+'</span>';
    categoryPadding = self.pad(categoryDifference - 2);
    paddings.selectedCategory = '<span style="color:'+color+';">'+categoryPadding+'</span>';

    var amountDifference = maxPaddingData.amount - String(parseInt(item.y)).length;
    var amountPadding = self.pad(amountDifference - 1);

    paddings.amount = '<span style="color:'+color+';">'+amountPadding+'</span>';

    return paddings;
  };

  self.pad = function(offset) {
    var PaddingString = "-";
    var padding = PaddingString;
    if (offset > 0) {
      _(offset).times(function(){ padding += PaddingString; });
    }
    return padding;
  };

  self.getTooltip = function(instance, widget) {
    var data = instance.series.data;
    var currentCategory = instance.series.name;
    var currentBidder = instance.x;
    var tooltip = "<b>" + currentCategory + ":</b><br/>";
    // padding adjustment
    var maxPaddingData = ChartUtils.calculatePaddingBoundaries(data);
    $.each( data, function(index, item ){
      var paddings = ChartUtils.getItemPaddings(maxPaddingData, item);
      if (currentBidder == item.category) {
        tooltip += '<span style="font-weight:bold; font-family: monospace; color:' + item.series.color + ';">' + item.category + ':</span>';
        tooltip += paddings.selectedCategory;
        tooltip += '<span style="font-weight:bold; color:' + item.series.color + ';">';
        tooltip += widget.chartData.currency + "</span>";
        tooltip += paddings.amount;
        tooltip += '<span style="font-weight:bold; color:' + item.series.color + ';">';
        tooltip += Highcharts.numberFormat( item.y, 0) + ' (' + self.calculatePercentage(item.y, item.stackTotal) + '%)' + '<br/>';
      }else{
        tooltip += '<span style="font-family: monospace;">' + item.category + ':</span>' + paddings.category + widget.chartData.currency + paddings.amount;
        tooltip += Highcharts.numberFormat( item.y, 0) + ' (' + self.calculatePercentage(item.y, item.stackTotal) + '%)' + '<br/>';
      }
    });
    return tooltip;
  };

  self.calculatePercentage = function(amount, total) {
    return parseFloat(amount / total * 100).toFixed(1);
  };

  self.reverseSeries = function() {
    var series1 = $.map(ChartData.series, function(e,i){ return e.name;});
    var series = ChartData.series.reverse();
    var series2 = $.map(ChartData.series, function(e,i){ return e.name;});
    ChartData.series = series;
  };

  self.usingRemoteData = false;

  self.initChart = function() {
    if (CommonUtils.isDataAvailable()) {
      BiddersUtils.renderBiddersList(false);
      BiddersUtils.renderBiddersList(true);
      BiddersUtils.setupSidebarEvents();
      self.renderChart();
    } else {
      $("#preselectBidders").height("261px");
      self.usingRemoteData = true;
      CommonUtils.pollForData(self.renderChart);
    }
  };

  self.showOnDropDown = function(target) {
    target.parents('ul').find('a').removeClass('selected');
    target.addClass('selected');
    target.parents('ul').parent().find('span').text(target.html()).data(target.data());
  };

  self.renderChart = function() {
    self.reverseSeries();
    //Initialize Chart and BreadCrumb
    $('#bids-comparison-chart').bidsChart( {chartData: ChartData, paddingTop: 265});
    $('#bids-breadcrumb').jBreadCrumb();
    $('.global-bids-sorting').first().click();

    if (self.usingRemoteData) {
      $("preselectBidders").removeAttr("style");
    }
  };

  self.redrawChart = function(sortBy) {
    if (typeof(sortBy) == "undefined") {
      sortBy = "byAmount";
    }
    self.sortingType = sortBy;
    $("#bids-comparison-chart").bidsChart("filterBidders");
    // $("#bids-comparison-chart").bidsChart("sortData", sortBy);
  };

  self.sortingType = null;

  self.maskChart = function() {
    var div = ".sub-content.graph";
    // $(div).css("height", "500px");
    CommonUtils.maskElement(div);
  };

  self.unmaskChart = function() {
    var div = ".sub-content.graph";
    // $(div).removeAttr("style");
    CommonUtils.unmaskElement(div);
    // $("#bids-comparison-chart").data().bidsChart._recalculateSize();
  };

  self.tenderID = null;
  self.tenderState = null;

  self.loadDataUrl = null;

  return self;
})();
